export type IWixSdk = ReturnType<typeof wixSdkFactory>;

/* @ngInject */
export function wixSdkFactory($window) {
  const WixSdk = $window.Wix;
  if (!WixSdk) {
    throw new Error('Wix sdk is not on a page');
  }
  return WixSdk;
}
